<template>
  <v-app id="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">报障工单详情 - {{companyInfo.COMPANY_NAME}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content class="us-v-content">
      <v-container style="font-size:0.9rem;padding:0.5rem;padding-bottom:3rem;">
        <OrderContent v-if="showAll" :company-info.sync="companyInfo" />
        <ShareContent v-else :company-info.sync="companyInfo" />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import OrderContent from './components/OrderContent'
import ShareContent from './components/ShareContent'
export default {
  components: { OrderContent, ShareContent },
  props: {
  },
  data() {
    return {
      curOrderLink: 'http://www.baidu.com?test=123',
      orderCode: '',
      checkCode: '',
      showAll: false,
      companyInfo: {}
    };
  },
  methods: {
    goBack() {
      this.$router.goBack()
    }
  },
  mounted() {
    var that = this
    that.orderCode = that.$route.params.code
    that.$api.bz.checkJoin({ order_code: that.orderCode }).then(res => {
      // console.log('checkJoin.res', res);
      if (!res.success) {
        // that.$toast.warning('检查失败');
        console.log('是否已经加入参与工单检查失败', res);
        return;
      }
      that.checkCode = res.msg
      if (that.checkCode !== '202') {
        that.showAll = true
      }
    })

    // that.curOrderLink = that.$AppHelper.getShareLink('/ShareOrder/' + that.orderCode);
    // console.log('curOrderLink', that.curOrderLink);
  },
  created() {}
};
</script>

<style scoped>

.us-v-content{
  overflow:auto !important;
  overflow-x:hidden !important;
  /* min-height: 200px !important; */
}

.us-icon{
  width: 30px;
  max-width: 30px;
  display: inline-block;
  text-align: center !important;
}

.us-icon i{
  font-size: 1rem;
}

.us-v-rating >>> .v-icon{
  padding: 0.1rem !important;
}

.us-label{
  color: #9b9b9b;

}

</style>
